import React, { useState, useEffect } from 'react';
import { supabase } from './supabaseClient';
import { Link } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';

export default function DiscoverV2UltraPro() {
  const [nubbi, setNubbi] = useState(null);
  const [loading, setLoading] = useState(true);
  const [changing, setChanging] = useState(false);

  const fetchRandomNubbi = async () => {
    setChanging(true);
    let { data, error } = await supabase.rpc('get_random_character');
    if (error) {
      console.error(error);
    } else {
      setTimeout(() => {
        setNubbi(data[0]);
        setChanging(false);
      }, 300);
    }
  };

  useEffect(() => {
    fetchRandomNubbi();
    setLoading(false);
  }, []);

  const loader = (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gradient-to-br from-blue-500 to-purple-600 text-white">
      <motion.div
        animate={{ rotate: 360 }}
        transition={{ repeat: Infinity, duration: 1, ease: "linear" }}
        className="w-24 h-24 mb-8"
      >
        <img src="/logooficial.png" alt="Loading Nubbi" className="rounded-full" />
      </motion.div>
      <div className="text-3xl font-extrabold">Loading Nubbi...</div>
    </div>
  );

  if (!nubbi || loading) {
    return loader;
  }

  const optimizedImage = (nubbi.image ?? '/fallback.png') + '?width=400&quality=60';

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-500 to-purple-600 text-white p-8">
      <h1 className="text-center text-5xl font-extrabold mb-12 drop-shadow-lg">🚀 Discover Nubbis</h1>

      <AnimatePresence mode="wait">
        <motion.div
          key={nubbi.id}
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -50 }}
          transition={{ duration: 0.5 }}
          className="flex flex-col md:flex-row justify-center items-center gap-16"
        >

          <div className="w-full md:w-1/2 flex justify-center">
            <img
              src={optimizedImage}
              alt={nubbi.name}
              loading="lazy"
              className="rounded-3xl shadow-2xl border-4 border-white max-w-[400px] max-h-[400px] object-cover"
            />
          </div>

          <div className="bg-white text-black rounded-3xl p-8 shadow-2xl w-full md:w-[400px]">
            <h2 className="text-3xl font-bold mb-4">{nubbi.name}</h2>
            <p className="text-lg"><b>NUBB-ID:</b> {nubbi.id}</p>
            <p className="text-lg">
              <b>Universe:</b> 
              <Link to={`/universes/${nubbi.universo}`} className="text-blue-600 underline ml-1">
                {nubbi.universo}
              </Link>
            </p>
            <p className="text-lg"><b>Tagline:</b> {nubbi.tagline ?? "—"}</p>
            <p className="text-lg"><b>VS Votes:</b> {nubbi.vs_votes}</p>
            <p className="text-lg">
              <b>Created by:</b> 
              <Link to={`/${nubbi.creador_url}`} className="text-blue-600 underline ml-1">
                {nubbi.creador_url}
              </Link>
            </p>

            <button
              onClick={fetchRandomNubbi}
              className="mt-8 bg-red-500 text-white font-bold py-3 px-8 rounded-xl text-xl shadow-lg hover:scale-105 transition"
              disabled={changing}
            >
              🔄 Next Nubbi
            </button>
          </div>
        </motion.div>
      </AnimatePresence>
    </div>
  );
}